import { render, staticRenderFns } from "./GoodsInfoAdmin.vue?vue&type=template&id=df3f4f92"
import script from "./GoodsInfoAdmin.vue?vue&type=script&lang=js"
export * from "./GoodsInfoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports